import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const deleteInventory = async (
  agree: boolean | null,
  params: stdObject,
) => {
  const {
    t,
    customUpdate,
    windowValues,
    setWindowValues,
    modalData,
    setModalData2,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;
  if (agree) {
    setMsg2("loading");
    let payloadDeleteInventory: stdObject = {
      id: modalData.id,
      warehouse: windowValues.ALMINV,
      item: windowValues.ARTINV,
      color: windowValues.COLINV,
    };
    console.log("payloadDeleteInventory: ", payloadDeleteInventory);
    const responseDeleteInventory: stdObject = await sendData({
      endPoint: "deleteInventory",
      payload: payloadDeleteInventory,
      logoutAction,
    });

    console.log("responseDeleteInventory: ", responseDeleteInventory);
    const { success, status } = responseDeleteInventory;
    if (success && status) {
      customUpdate.current = { mainInfo: "INV" };
      closeMsg(2);
      closeMsg();
      setWindowValues({});
    } else {
      setMsg2("error");
    }
  } else {
    setMsg2("custom2");
    setModalData2({
      code: "warning",
      title: t("p.askDeleteInventory"),
      buttons: [
        {
          label: t("p.delete"),
          onClick: () => deleteInventory(true, params),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    });
  }
};
